import { useStyletron } from "baseui";
import { FlexGrid, FlexGridItem } from "baseui/flex-grid";
import { HeadingXLarge, ParagraphLarge } from "baseui/typography";
import React from "react";
import { CenterContentLane } from "../chrome/DocsContentContainer";
import LookingForSomethingElse from "./LookingForSomethingElse";

interface LandingProps {
  title: string;
  contents: string[];
  children?: React.ReactNode;
}

const Landing = ({ title, contents, children }: LandingProps) => {
  const [css, $theme] = useStyletron();
  return (
    <CenterContentLane data-testid="center-content-lane" $isHidden={false} $tableOfContents>
      <HeadingXLarge marginBottom="24px" marginTop="40px">
        {title}
      </HeadingXLarge>
      <FlexGrid flexGridColumnCount={[1, 2]} gridGap={$theme.sizing.scale800}>
        <FlexGridItem>
          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              width: "100%",
              gap: $theme.sizing.scale800,
            })}
          >
            {contents.map((content, index) => (
              <ParagraphLarge key={index}>{content}</ParagraphLarge>
            ))}
          </div>
          {children}
        </FlexGridItem>
        <FlexGridItem
          overrides={{
            Block: {
              style: {
                flexBasis: "325px",
                flexGrow: 0,
                "@media screen and (max-width: 850px)": {
                  flexBasis: "100%",
                  order: 1,
                },
              },
            },
          }}
        >
          <LookingForSomethingElse />
        </FlexGridItem>
      </FlexGrid>
    </CenterContentLane>
  );
};

export default Landing;
